// extracted by mini-css-extract-plugin
export default {"headings":"About_headings__O-KvJ","title":"About_title__rDDoF","content":"About_content__2X8BJ"};